//
//
//
//
//
//

import TableAuditTask from './table-audit-task.vue';

export default {
    components: {
        TableAuditTask,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        billId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    computed: {
        modelVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            },
        },
    },
};
